import { render, staticRenderFns } from "./ActiveOrderListOnboarding.vue?vue&type=template&id=20ba7ee8&"
import script from "./ActiveOrderListOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ActiveOrderListOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports